var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var colors = require("../colors/colors");
var HandleGridPopupInfo = require("./handleGridPopupInfo.js");

var HandleView = function (view, gui, idx, handleModel, parentGroup, layers) {
    var self = this;
    self.view = view;
    self.handleViews = (view.handles ? view.handles : null);
    self.gui = gui;
    self.idx = (idx != undefined ? idx : -1);
    self.handleModel = handleModel;
    self.interactionModel = self.handleModel.parent();

    self.cameraModel = self.gui.editorModel.cameraModel();

    // some data models do not have angles
    if (self.handleModel.modelData != undefined && self.handleModel.modelData.angle != undefined) {
        self.angle = self.handleModel.modelData.angle;
    } else {
        self.angle = null;
    }

    self.svgHandle = null;
    self.svgCircle = null;

    self.initGroups(parentGroup, [layers.interaction, layers.interactionControl], handleModel);

    self.svgGroup = self.getGroupInfo(layers.interaction).svgGroup;
    self.controlGroup = self.getGroupInfo(layers.interactionControl).svgGroup;

    self.HandleGridPopupInfo = new HandleGridPopupInfo(0, self.handleModel.modelData, self.cameraModel, self.gui, self.svgGroup);

    $(self.svgGroup).empty();
    $(self.controlGroup).empty();

    this.handleModel.highlighted.onChange(self, function () {
        self.configHandle();
    }, 10);

    self.cameraModel.viewS.onChange(self, function () {
        self.gui.heavyHandler.scheduleHeavy('update_view', self.configHandle, self, [], self);
    }, 10);

    this.handleModel.pos.onChange(self, function () {
        self.gui.heavyHandler.scheduleHeavy('update_view', self.configHandle, self, [], self);
    }, 10);

    this.interactionModel.infocus.onChange(self, function () {
        self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    }, 10);
    if (self.angle != null && self.angle.onChange != undefined) {
        self.angle.onChange(self, function () {
            if (self.handleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rupdateView', self.configHandle, self, [], self);
        }, 10);
    }
    self.handleModel.onDie(self, function () {
        self.emptySvgGroups();
        self.svgHandle = null;
        self.svgCircle = null;
        self.HandleGridPopupInfo.emptySvgGroups();
    }, 10);

    self.drawIfNeeded();
};

lib_core.mixin(HandleView, editor_2d.DrawingElement);

module.exports = HandleView;

HandleView.prototype.drawIfNeeded = function () {
    if (this.handleModel.isAlive()
        && (this.interactionModel.infocus() || this.handleModel.selected())
        && (!this.handleModel.isHidden || !this.handleModel.isHidden())) {
        this.draw();
    } else {
        this.emptySvgGroups();
        this.HandleGridPopupInfo.emptySvgGroups();
    }
};

/**
 * We want to change the properties of the handle without creating a new one
 * @author E.Pataky
 * @function configHandle
 */
HandleView.prototype.configHandle = function() {
    var pos = this.handleModel.pos();
    this.size = 8 / this.cameraModel.viewS();
    this.stroke = 1 / this.cameraModel.viewS();

    if(this.svgCircle != null) {
        this.gui.svg.configure(this.svgCircle, {
            cx: pos.x,
            cy: pos.y,
            r: this.size/2,
            'fill' : this.handleModel.highlighted() ? colors.handleFillSelected : colors.handleFill,
            'stroke': colors.handleStroke,
            'strokeWidth': this.stroke,
            'transform': (this.angle != null ?
                (this.data.angle() ? 'rotate(' + this.data.angle() + ' ' +
                pos.x + ' ' + pos.y + ')' : '') : '')
        }, true);
    }

    if(this.svgHandle != null) {
        this.gui.svg.configure(this.svgHandle, {
            cx: pos.x,
            cy: pos.y,
            r: this.size/2,
            'strokeWidth': this.stroke
        }, true);
    }

    this.HandleGridPopupInfo.configPopInfo(this.handleModel.highlighted(),
        this.handleModel.modelData,
        true, this.idx);
};

HandleView.prototype.draw = function () {
    var self = this;

    $(self.svgGroup).empty();
    $(self.controlGroup).empty();
    self.HandleGridPopupInfo.emptySvgGroups();

    self.c = self.handleModel.pos();
    if(self.c != null) {
        self.size = 8 / self.cameraModel.viewS();
        self.stroke = 1 / self.cameraModel.viewS();
        self.data = self.handleModel.modelData;
        self.hmX = self.c.getX();
        self.hmY = self.c.getY();

        self.svgCircle = self.gui.svg.circle(self.svgGroup,
            self.c.x,
            self.c.y,
            self.size/2,
            {
                'fill' : self.handleModel.highlighted() ? colors.handleFillSelected : colors.handleFill,
                'stroke': colors.handleStroke,
                'strokeWidth': self.stroke,
                'transform': (self.angle != null ?
                    (self.data.angle() ? 'rotate(' + self.data.angle() + ' ' +
                    self.hmX + ' ' + self.hmY + ')' : '') : '')
            }
        );

        // use for debugging, comment out when not needed - please do not delete
        /*if(self.handleModel.handleGridIndex) {
            var hgi = self.handleModel.handleGridIndex();
            var hgiAct = self.handleModel.interactionModel().handleModes.get(hgi-1);
            self.gui.svg.text(self.svgGroup, self.c.x + self.size,
                self.c.y - 2*self.size*(hgiAct%3)/ self.cameraModel.viewS(),
                hgi + "[" + (hgiAct+1) + "]",
                {'font-size': '6pt'});
            hgiAct = hgi = null;
        }*/

        self.svgHandle = self.gui.svg.circle(self.controlGroup,
            self.c.x, self.c.y, self.size/2, { 'strokeWidth': this.stroke });

        self.HandleGridPopupInfo.configPopInfo(self.handleModel.highlighted(),
            self.handleModel.modelData,
            true,
            self.idx);

        $(self.svgHandle).mousedown(
                function (event) {
                    self.onMouseDown(event);
                    return false;
            }).hover(
                function(event){
                    self.onMouseOver(event);
                    return false;
                },
                function(event){
                    self.onMouseOut(event);
                    return false;
                });
    }
};

HandleView.prototype.onMouseDown = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.HANDLE_MOUSE_DOWN)
        .fromJSEvent(event)
        .element(this.handleModel)
        .data('mouseCoord', this.gui.relativeMouseCoord(event))
        .data('notFocusable', true)
        .data('handleIndex', this.idx) // save which handle this is in the event
        .data('handleType', 1); // 1=normal handle, 2=selection grid handle

    return this.gui.stateMachine.handle(cEvent);
};

HandleView.prototype.onMouseOver = function(event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.HANDLE_MOUSE_OVER)
        .fromJSEvent(event)
        .element(this.handleModel)
        .data('handleIndex', this.idx)
        .data('handleType', 1); // 1=normal handle, 2=selection grid handle
    return this.gui.stateMachine.handle(cEvent);
};

HandleView.prototype.onMouseOut = function(event) {
    var self = this;
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.HANDLE_MOUSE_OUT)
        .fromJSEvent(event)
        .element(this.handleModel)
        .data('handleIndex', this.idx)
        .data('handleType', 1); // 1=normal handle, 2=selection grid handle
    return this.gui.stateMachine.handle(cEvent);
};

HandleView.prototype.clickAction = function () {
};

